import { IFORM } from 'featureLib';
import { TYPEOF_ORDER } from 'common/constants/app.constants';
import { getAddress } from 'common/utils/app.utils';

const getRequestType = (formSchema: IFORM) => {
  const selectedTypeOfOrder = formSchema['typeOfOrder'].value?.key;

  let orderType = selectedTypeOfOrder;
  let orderSubType = selectedTypeOfOrder;

  if (selectedTypeOfOrder === TYPEOF_ORDER.UPGRADE || selectedTypeOfOrder === TYPEOF_ORDER.SHIFTING) {
    orderType = 'CHANGE_ORDER';
  }

  if (selectedTypeOfOrder === TYPEOF_ORDER.NEW_PRE_ORDER) {
    orderType = 'PRE_ORDER';
    orderSubType = TYPEOF_ORDER.NEW;
  }

  if (selectedTypeOfOrder === TYPEOF_ORDER.UPGRADE_PRE_ORDER) {
    orderType = 'PRE_ORDER';
    orderSubType = TYPEOF_ORDER.UPGRADE;
  }

  return {
    orderType,
    orderSubType
  };
};

const getPanGstKey = (formSchema: IFORM) => {
  if (formSchema['searchType']?.value?.id === 'pan') {
    return 'panNumber';
  }

  return 'gstNumber';
};

export const prepareCreateLeadPayload = (formSchema: IFORM) => {
  const request = {} as any;
  console.log(formSchema, 'formSchema');
  const cityData = formSchema['city']?.value?.data;
  // request['partyId'] = formSchema['selectedAccount'].value?.partyId;
  request['pinCode'] = formSchema['accountName'].value?.address?.pincode || formSchema['pincode']?.value;
  request['state'] = formSchema['accountName'].value?.address?.state || cityData?.state;
  request['country'] = formSchema['accountName'].value?.address?.country || cityData?.country;
  request['email'] = formSchema['emailAddress'].value;
  request['cityName'] = formSchema['accountName'].value?.address?.city || cityData?.city;
  request['address'] = formSchema['address'].value || formSchema['addressLine']?.value;
  request['companyName'] = formSchema['accountName'].value?.key;
  request['customerAccountNumber'] = formSchema['accountName'].value?.rootAccountNumber;
  request['phoneNumber'] = formSchema['phoneNumber'].value;
  request['orderType'] = getRequestType(formSchema).orderType;
  request['leadSource'] = 'SELF_CARE';
  request['productName'] = formSchema['productType'].value?.key;
  request['customerName'] = formSchema['fullName'].value;
  request['salesAgencyCode'] = formSchema['salesCode'].value;
  request[getPanGstKey(formSchema)] = formSchema['searchValue'].value;
  request['olmId'] = formSchema['olmId'].value;
  request['initiatorName'] = formSchema['initiatorFullName'].value;
  request['initiatorPhoneNumber'] = formSchema['initiatorPhoneNumber'].value;
  // request['typeOfOrder'] = formSchema['typeOfOrder'].value?.key;
  // request['orderNickName'] = formSchema['orderNickName'].value;
  // request['journeyType'] = formSchema['siteType'].value?.id;
  // request['orderSubType'] = getRequestType(formSchema).orderSubType;

  // if (formSchema['typeOfOrder'].value?.key === TYPEOF_ORDER.NEW_PRE_ORDER || formSchema['typeOfOrder'].value?.key === TYPEOF_ORDER.UPGRADE_PRE_ORDER) {
  //   request['loiAvailable'] = formSchema['loiAvailable'].value;
  // }

  return request;
};
